import React, { useEffect, useState } from 'react';
import Nav from '../components/Navigation/Nav';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Frontend/Footer/Footer';

const ClientLayout = () => {

  const location = useLocation();

  const [show_footer, showFooter] = useState(true)

  useEffect(() => {
    // Check URL path and set the expanded state
    if (location.pathname.indexOf('ai_assistant') !== -1) {
      showFooter(false);
    }else{
      showFooter(true);
    }

  }, [location.pathname]);

  return (
    <div className="main-layout">
      <Nav />
      <div className="row">
        <div className="content col-md-12">
          <div className="main_content">
            <Outlet />
          </div>
          {show_footer && <Footer /> }
        </div>
      </div>
    </div>
  );
};

export default ClientLayout;
